import { graphql } from "react-relay";

export const MESSAGE_DISPATCH_FRAGMENT = graphql`
	fragment editMessageDispatchButton_MessageDispatchFragment on MessageDispatch {
		id
		dispatchedAt
	}
`;
